import { ApiNetWork } from "@/network/apiNet/apiNet";

//测试接口
export function getVersion(data) {
  return ApiNetWork.get("app/encryptionVersion", data);
}
// 首页-房间数据
export function getHomeRoomData() {
  return ApiNetWork.get("app/encryptionTypeHostRecomm");
}
// 首页-轮播图
export function getSwipe() {
  return ApiNetWork.get("app/encryptionBanner");
}
// 首页-今日推荐
export function encryptionRecommMatch() {
  return ApiNetWork.get("app/encryptionRecommMatch");
}
// 首页-垂直文字轮播
export function encryptionTxtShuff() {
  return ApiNetWork.get("app/encryptionTxtShuff");
}
// 首页-明星主播
export function hostRankingList(data: any) {
  return ApiNetWork.get("app/hostRankingList", data);
}
//首页篮球足球分类
export function HostRecommNew(data: any) {
  return ApiNetWork.get("app/encryptionTypeHostRecommNew", data);
}
// 首页-热门球圈
export function getHomeListHotNew() {
  return ApiNetWork.get("app/ballNewsListHome");
}
// 首页-主播推荐
export function getTypeRecommend() {
  return ApiNetWork.get("app/encryptionTypeHostRecomm", { is_has_video: "0" });
}
// 首页-（主播和精彩集锦更多）
export function encryptionTypeHostRecomm(data: any) {
  return ApiNetWork.get("app/encryptionTypeHostRecomm", data);
}
// 首页-快讯
export function encryptionQiutxNews(data: any) {
  return ApiNetWork.get("app/encryptionNewsData", data);
}
// 首页-快讯-内容
export function encryptionNewsDetail(data: any) {
  return ApiNetWork.get("app/encryptionNewsDetail", data);
}
// 赛程
export function encryptionMatch(data: any) {
  return ApiNetWork.get("app/encryptionMatchNew", data);
}

// 球圈数据
export function getballNewList(data) {
  return ApiNetWork.get('app/ballNewsList', data);
}

// 球圈详情
export function ballNewsDetail(data: any) {
  return ApiNetWork.get('app/ballNewsDetail', data);
}
// 获取球圈详情评论数据
export function ballNewsCommentList(data: any) {
  return ApiNetWork.get('app/ballNewsCommentList', data);
}

// 球圈详情点赞
export function ballNewsZan(data: any) {
  return ApiNetWork.get('app/ballNewsZan', data);
}

// 球圈详情评论
export function ballNewsComment(data: any) {
  return ApiNetWork.get('app/ballNewsComment', data);
}

// 搜索主播，房间
export function encryptionHostSearch(data: any) {
  return ApiNetWork.get('app/encryptionHostSearch', data);
}
// 搜索赛程
export function encryptionSearchMatch(data: any) {
  return ApiNetWork.get('app/encryptionSearchMatch', data);
}

// 搜索-大家都在搜展示数据
export function encryptionSearchShow(data: any) {
  return ApiNetWork.get('app/encryptionSearchShow', data);
}

// 搜索-搜索比赛
export function encryptionHomeSearchData(data: any) {
  return ApiNetWork.get('app/encryptionHomeSearchData', data);
}

// 首页-正在热播 分页: { page, limit }
export function encryptionTypeHostRecommHotPlay(data: any) {
  return ApiNetWork.get('app/encryptionTypeHostRecommHotPlay', data);
}

export function encryptionHomeOptionType() {
  return ApiNetWork.get('app/encryptionHomeOptionType', {});
}

// 世界杯主题页
export function encryptionWorldcup() {
  return ApiNetWork.get('app/encryptionWorldcup', {});
}

export function noticeConfig() {
  return ApiNetWork.get('app/noticeConfig', {});
}

//回放
export function encryptionLiveRecordList(is_home_page = 0) {
  return ApiNetWork.get('app/encryptionLiveRecordList', { is_home_page: is_home_page });
}

export function encryptionGetPixelInfo(data:any) {
  return ApiNetWork.get('app/encryptionPixel', data);
}

//快讯点赞
export function encryptionNewsLike(data: any) {
  return ApiNetWork.get("app/encryptionNewsLike", data);
}
